import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActionListArchivedService } from '../dashboard/action-list-archived/action-list-archived.service';
import clonedeep from 'lodash.clonedeep';
import { DashboardService } from '../dashboard/dashboard.service';
import { SharedService } from '../services/shared.service';

@Component({
	selector: 'app-action-list-order',
	templateUrl: './action-list-order.component.html',
	styleUrls: ['./action-list-order.component.scss']
})
export class ActionListOrderComponent implements OnInit {
	@ViewChild(MatSort) sort: MatSort;
	actionList = new MatTableDataSource<any>([]);
	searchQuery: string = "";
	displayedColumns = ['select', 'name', 'star'];
	bgTextColor = "#000000";
	constructor(
		private _actionListService: ActionListArchivedService,
		private _snackBar: MatSnackBar,
		private _sharedService: SharedService,
		private _dashboardService: DashboardService,
		private _changeDetectionRef: ChangeDetectorRef
	) {
		this._dashboardService.sharedCount.subscribe((value) => {
			this.onInit();
		});
		this._sharedService.searchChange.subscribe(value => {
			this.searchQuery = value;
			this.actionList.filter = value.toLowerCase();
		});
	}

	ngOnInit() {
		this.onInit();
	}

	ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

	check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

	onInit(): void {
		if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
		this._actionListService.getActionTypes(localStorage.getItem('organization')).subscribe((response) => {
			if (response["success"]) {
				this.actionList = new MatTableDataSource(response["data"]);
				this.actionList.sort = this.sort;
				this.actionList.filter = this.searchQuery.toLowerCase();
			}
		}, (error) => {
			console.log(error);
			this.openSnackBar("Server side error occurred");
		})
	}

	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
			duration: 2000
		});
	}


	archiveActionTypeForms(_id) {
		// this._sharedService.confirmationDialog("Are you sure you want to archive the List and forms in it?", () => {
		this._sharedService.confirmationDialog("Are you sure you want to archive the List?", () => {
			let requestData = {
				actionTypeId: _id,
				updated_by: {
					username: localStorage.getItem('username'),
					user_id: localStorage.getItem('userId'),
					organization_id: localStorage.getItem('organization')
				}
			};
			this._dashboardService.archiveActionTypeForms(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar(response["message"]);
					this._dashboardService.refreshCount([]);
					this.onInit();
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	deleteActionTypeForms(_id) {
		// this._sharedService.confirmationDialog("Are you sure you want to delete the List and forms in it?", () => {
		this._sharedService.confirmationDialog("Are you sure you want to delete the List?", () => {
			let requestData = {
				actionTypeId: _id,
				deleted_by: {
					username: localStorage.getItem('username'),
					user_id: localStorage.getItem('userId'),
					organization_id: localStorage.getItem('organization')
				}
			};
			this._dashboardService.deleteActionTypeForms(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar(response["message"]);
					this._dashboardService.refreshCount([]); // Refreshing action list in header nav
					this.onInit();
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	dropRow(event: CdkDragDrop<string[]>) {
		if (event.previousIndex !== event.currentIndex) {
			let url = window.location.pathname.split("/");
			// Swap the elements around
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
			this.actionList.data = clonedeep(this.actionList.data);
			let actionLists = [];
			let order = 0;
			this.actionList.data.forEach((actionType) => {
				let obj = {
					actionTypeId: actionType._id,
					order: order
				};
				actionLists.push(obj);
				order = order + 1;
			})
			let requestData = {
				actionLists: actionLists
			};

			this._sharedService.updateActionListOrder(requestData).subscribe((response) => {
				if (response["success"]) {
					this.onInit();
					this._dashboardService.refreshCount([]);
				}
			}, (error) => {
				console.log(error);
			});
		}
	}

	onReloadClick(): void {
		this.onInit();
	}

	onChange = (val) => {
		console.log(val);
	}

	editField = (action, key) => {
		if (action[key]) {
			action['dummy' + key] = action[key]
		}
		action['edit' + key] = true;
	}

	saveEditedFeilds = (action, value, key) => {
		if (action['name'] === value) {
			action['edit' + key] = false;
			return;
		}
		if (value.length === 0) {
			this.openSnackBar("List name cannot be left empty");
			return;
		}
		var requestData = {
			actionTypeId: action._id,
			name: value,
			updated_by: {
				username: localStorage.getItem('username'),
				user_id: localStorage.getItem('userId'),
				organization_id: localStorage.getItem('organization')
			}
		}
		this._sharedService.updateActionListName(requestData).subscribe((response) => {
			if (response["success"]) {
				this.onInit();
				this._dashboardService.refreshCount([]);
			}
		}, (error) => {
			console.log(error);
		});
	}

	onCancel(action, key) {
		if (action[key]) {
			action['dummy' + key] = action[key]
		}
		action['edit' + key] = false;
	}

	hasActiveFilters(): boolean {
		return !!(this.actionList && this.actionList.filter);
	}

	clearFilter(type: string): void {
		if (type === 'search') {
			this.actionList.filter = '';
			this._sharedService.searchChange.next('');
		}
	}

	applyFilters(): void {
		// Action List currently only uses global search from header
		this._changeDetectionRef.detectChanges();
	}

}
